import { tryParseInt } from '@witkac/utils/tryParseInt';

import { validationMessages } from './validationMessages.schema';

const MINIMUM_LENGTH = tryParseInt(process.env.VUE_APP_PASSWORD_MINIMUM_LENGTH, 12);
const MINIMUM_UPPERCASE = tryParseInt(process.env.VUE_APP_PASSWORD_MINIMUM_UPPERCASE, 1);
const MINIMUM_LOWERCASE = tryParseInt(process.env.VUE_APP_PASSWORD_MINIMUM_LOWERCASE, 1);
const MINIMUM_NUMBERS = tryParseInt(process.env.VUE_APP_PASSWORD_MINIMUM_NUMBERS, 1);

function countMatches(regexp: string): string {
  return `($value.match(/${regexp}/g) || []).length`;
}

export default {
  title: 'Potwierdzenie hasła',
  type: 'object',
  properties: {
    currentPassword: {
      type: 'string',
      title: 'Obecne hasło',
      disabled: '!this.currentPasswordRequired',
      fieldRequired: true,
      minLength: 8,
      validationMessages: {
        required: 'Błąd: Hasło jest wymagane.',
        minLength: 'Błąd: Minimalna długość hasła wynosi 8.'
      }
    },
    password: {
      type: 'string',
      title: 'Hasło',
      fieldRequired: true,
      minLength: MINIMUM_LENGTH,
      validationMessages: {
        required: 'Błąd: Hasło jest wymagane.',
        minLength: `Błąd: Minimalna długość hasła wynosi ${MINIMUM_LENGTH}.`
      },
      validFunc: [
        `var uppercaseAmount = ${countMatches('[A-Z]')};`,
        `if (uppercaseAmount < ${MINIMUM_UPPERCASE}) {` +
          `  return "Błąd: Minimalna liczba wielkich liter wynosi ${MINIMUM_UPPERCASE}.";`,
        '}',
        `var lowercaseAmount = ${countMatches('[a-z]')};`,
        `if (lowercaseAmount < ${MINIMUM_LOWERCASE}) {` +
          `  return "Błąd: Minimalna liczba małych liter wynosi ${MINIMUM_LOWERCASE}.";`,
        '}',
        `var numbersAmount = ${countMatches('[0-9]')};`,
        `if (numbersAmount < ${MINIMUM_NUMBERS}) {` +
          `  return "Błąd: Minimalna liczba cyfr wynosi ${MINIMUM_NUMBERS}.";`,
        '}',
        'if ($value && this.currentPassword && $value === this.currentPassword) {',
        '  return "Błąd: Nowe hasło musi być różne od obecnego."',
        '}',
        'return true;'
      ]
    },
    repeat: {
      type: 'string',
      title: 'Powtórz hasło',
      fieldRequired: true,
      validFunc: '$value && this.password ? $value === this.password : true',
      validationMessages: {
        required: 'Błąd: Powtórzenie hasła jest wymagane.',
        validFunc: 'Błąd: Oba hasła muszą być takie same.'
      }
    },
    currentPasswordRequired: {
      type: 'boolean',
      computed: true,
      default: false
    }
  },
  allOf: [validationMessages]
};
